import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import CommonButton from "../../commonButton";
import withModal from "../../withModal";
import { useToast } from "../../../context/TostContext";
import InputField from "../../form/InputField";

const ContactPurposeModal = ({ onClose, onSubmit, purpose, isLoading }) => {
  const [title, setTitle] = useState("");
  const toast=useToast();
  useEffect(() => {
    if (purpose) {
      setTitle(purpose.title || "");
    } else {
      setTitle("");
    }
  }, [purpose]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title.trim()) {
      toast.error("Please enter a title");
      return;
    }

    const data = {
      title
    };

    onSubmit(data);
  };

  return (
    <Form onSubmit={handleSubmit} noValidate>
      <Modal.Body>
        <InputField
          label={{ name: "Title" }}
          required
          input={{
            type: "text",
            placeholder: "e.g. Sales, Support, Networking",
            value: title,
            onChange: (e) => setTitle(e.target.value),
            required: true,
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <CommonButton
          title="Cancel"
          type="button"
          variant="outline"
          onClick={onClose}
        />
        <CommonButton
          title={purpose ? "Save Changes" : "Add Purpose"}
          type="submit"
          variant="primary"
          isLoading={isLoading}
        />
      </Modal.Footer>
    </Form>
  );
};

export default withModal(ContactPurposeModal);
